import { ADMIN_PASSWORD, ADMIN_USERNAME } from "../config/adminAuth";

const SHIPROCKET_SYNC_PATH = "/api/shiprocket/sync";

export async function syncShiprocketTracking() {
  try {
    const res = await fetch(SHIPROCKET_SYNC_PATH, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({
        manual: true,
        adminUsername: ADMIN_USERNAME,
        adminPassword: ADMIN_PASSWORD,
      }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || data?.ok === false) {
      return {
        ok: false,
        message: data?.message || `Shiprocket sync failed (${res.status})`,
        data,
      };
    }
    return { ok: true, data };
  } catch (err) {
    return {
      ok: false,
      message: err?.message || "Network error while syncing Shiprocket tracking.",
    };
  }
}
